var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[_c('h3',[_vm._v(_vm._s(_vm.$t("positions_history")))]),_vm._v(" "),_c('highcharts',{ref:"highchart",attrs:{"options":_vm.chartOptions,"updateArgs":_vm.updateArgs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }